const base = "inline-flex items-center rounded border px-1.5 py-0.5 text-[10px] font-mono font-semibold uppercase tracking-wide";

const STATUT = {
  OK: "bg-green-50 text-green-700 border-green-200",
  ERREUR: "bg-red-50 text-red-600 border-red-200",
  SURPLUS: "bg-yellow-50 text-yellow-700 border-yellow-200",
  ANNULEE: "bg-slate-100 text-slate-600 border-slate-300",
  ECART_HABITUEL: "bg-orange-50 text-orange-700 border-orange-200",
  ESTIME: "bg-sky-50 text-sky-700 border-sky-200",
};
const LIBELLE = { ECART_HABITUEL: "Écart habituel", ESTIME: "Taxes estimées" };

export const StatusBadge = ({ statut, testId, plateforme }) => (
  <span className={`${base} ${STATUT[statut] || ""}`} data-testid={testId}>{statut === "ECART_HABITUEL" && plateforme ? `Écart ${plateforme} habituel` : LIBELLE[statut] || statut}</span>
);

export const PlatformBadge = ({ plateforme }) =>
  plateforme ? (
    <span
      className={`${base} ${
        plateforme === "Airbnb" ? "bg-[#FF385C]/10 text-[#E0294B] border-[#FF385C]/30" : "bg-[#003580]/10 text-[#003580] border-[#003580]/30"
      }`}
    >
      {plateforme}
    </span>
  ) : (
    <span className="text-xs text-slate-400">—</span>
  );

const MATCH = {
  valide: ["Rapproché", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  propose: ["À valider", "bg-amber-50 text-amber-700 border-amber-200"],
};

export const MatchBadge = ({ match, testId }) => {
  const [label, cls] = match ? MATCH[match.statut] : ["Non rapproché", "bg-slate-100 text-slate-500 border-slate-200"];
  return (
    <span className={`${base} ${cls}`} data-testid={testId}>
      {label}
      {match?.type === "groupe" && <span className="ml-1 opacity-70">· groupé</span>}
    </span>
  );
};

export const REGUL_LABELS = {
  a_faire: "À traiter",
  contestee: "Contestée",
  regularisee: "Régularisée",
  absorbee: "Absorbée",
};
